export default {
  links: {
    home: 'Home',
    plans: 'Plans',
    interiors: 'Interiors',
    neighbourhood: 'Neighbourhood',
    amenities: 'Amenities',
    developer: 'Developer',
    register: 'Register',
    contact: 'Contact',
  },

  // FOOTER
  footer: {
    getInTouch: 'Get In Touch',
    contactCopy: 'Contact us today for more info about Ivy On The Park',
    email: 'info@ivyonthepark.com',
    presentationCentre: 'Presentation Centre',
    closed: 'Presentation Centre is now closed.',
    tel: 'Tel: ',
    telNumber: '604-225-0117',
    address:
      'Open by private appointment.<br/>5629 Birney Ave, Vancouver, BC V6S 0A5',
    managedBy: 'Managed By',
    marketedBy: 'Marketed By',
    disclaimer:
      'THIS IS NOT AN OFFERING FOR SALE. ANY SUCH OFFERING CAN ONLY BE MADE BY WAY OF DISCLOSURE STATEMENT. E.& O.E.',
  },

  // HOME
  home: {
    title: `
      <span>
        POINT GREY
        <br />
        LIVING
      </span>
    `,
    subtitle: '| A STRIKING URBAN FORM |',
    copy: `The Ivy on the Park residences offer a rare combination of nature and
    culture, in an unrivalled Vancouver location. This Westside address,
    which provides every convenience of Wesbrook Village, is surrounded by
    open spaces, world-class cultural and educational facilities,
    beautiful parks, ocean and trees. Unlike anywhere else in the world,
    here you will experience the ultimate expression of lifestyle and
    urban design.`,
    registerBtn: 'Register Now',
    cards: [
      {
        title: 'A Variety <br /> of Homes',
        subtitle: 'The Floorplans',
        learnMore: 'View Floorplans',
      },
      {
        title: 'Versatility of Kitchens',
        subtitle: 'A Gourmet Experience',
        learnMore: 'Learn More',
      },
      {
        title: 'Unparalleled Location',
        subtitle: 'The Neighbourhood',
        learnMore: 'Learn More',
      },
      {
        title: 'Enriching <br /> Extras',
        subtitle: 'The Amenities',
        learnMore: 'Learn More',
      },
      {
        title: 'The Wall Group of Companies',
        subtitle: 'The Developer',
        learnMore: 'Learn More',
      },
    ],
    register: 'Register',
  },

  // PLANS
  plans: {
    heading: `A Variety<br />Of Homes`,
    types: ['tower', 'mid-rise', 'townhomes'],
    filters: [
      'studio',
      '1 Bed',
      '2 Bed',
      '2 Bed + Den',
      '3 Bed',
      '3 Bed + Den',
    ],
    studio: 'Studio',
    plan: 'Plan',
    bed: 'Bed',
    bath: 'Bath',
    den: 'Den',
    sqft: 'SF',
    interior: 'Interior',
    exterior: 'Exterior',
    download: 'Download Plan',
  },

  // INTERIORS
  interiors: {
    title: 'Understated <br /> Elegance',
    subtitle: 'The Interiors',
    copy: `Interiors at Ivy on the Park are equally inspired by the
    stunning modern architecture and the lush forest just outside
    windows. Warm and inviting colours and textures complement the
    natural palette seen throughout UBC, and suit a spectrum of
    style preferences. From European style cabinets to centrepiece
    ensuite showers to engineered hardwood flooring, luxury is a
    consistent theme within homes.`,
    captions: ['Living Room', 'Townhome Interior'],
    featuresFinishes: 'Features & Finishes',
    downloadBtn: 'Download PDF',
    features: [
      {
        title: 'Exceptional Living',
        list: [
          'Spacious layouts welcome natural light from expansive windows',
          'Two beautiful colour schemes to choose from',
          'Stained white oak hardwood flooring sweeps throughout all homes',
          'Dimmable flush-mount lighting with chrome trim in walk-in closet',
          'Blomberg front-load washer & vented dryer in designated laundry room with engineered polished stone countertops and custom storage in select homes',
          'In-home air conditioning for year-round climate comfort',
        ],
      },
      {
        title: 'Gourmet Kitchens',
        list: [
          'Engineered quartz countertops offer generous workspace, and are complemented by a large format porcelain tile backsplash',
          'Premium appliance package:',
          [
            '30" custom integrated panel built-in refrigerator with bottom freezer drawer',
            '30" stainless steel gas cooktop',
            '30" stainless steel speed oven',
            '30" stainless steel single wall oven with canopy & chimney hood fan',
            '24" custom integrated panel dishwasher',
          ],
          'Thermador 18" built-in integrated wine refrigerator exclusively in select homes',
          'Soft close European style cabinetry, with integral pulls, designed for abundant and organized storage',
          'Undermount, double basin sink in polished chrome with Kohler pull-out faucet',
          'Under-cabinet LED light fixture with chrome finish for softer illumination',
          '1⁄2 HP Food Disposal for easy clean up',
          'Screwless Adorne Receptacles with USB Charging ports',
        ],
      },
      {
        title: 'Luxurious Bathrooms',
        list: [
          'Porcelain tiles overlay ensuite and main bathroom floors',
          'Engineered polished quartz countertops in ensuite and main bathroom',
          'Frameless glass shower enclosure, with large format porcelain tile lining shower walls, shower base, and quartz shower curb',
          'Ensuite centrepiece shower features invigorating Kohler shower kit with Rite Temp valve trim, and is flanked by custom millwork storage',
          'Backlit mirrors add clarity in ensuites',
          'Relaxing Hytec acrylic bathtub with Kohler Purist wall-mount bath spout and Rite Temp pressure-balancing, chrome shower-head',
          'Kohler undermount circular sink with polished chrome Purist Collection faucet',
        ],
      },
      {
        title: 'Balcony Features',
        list: [
          'Incredible views over Pacific Spirit Park and the Strait of Georgia',
          'Features Trex Composite Decking, a low maintenance, high performance, eco-friendly (made with 95% recycled materials) decking that is durable, fade & stain resistant, and can be cleaned with soap and water.',
          'Dual gas outlets on balconies for all townhomes, penthouses and 3 bedroom homes to enjoy barbeque dinners with friends. Add a gas powered heat source and enjoy your space all year round.',
        ],
      },
      {
        title: 'Enriching Extras',
        list: [
          'Large fitness room and yoga studio for strengthening body and mind',
          'Enjoy quietude in an intimate library',
          'A music lounge with piano and seating for recitals and hosting friends, with an additional private music room for individual practice',
          'Work or study in individual co-work spaces or have group sessions in the teamwork space',
          'Socialize with neighbours in the attractive club room, connecting with an outdoor patio',
          'Landscaped outdoor garden space',
          'National Home Warranty coverage',
        ],
      },
      {
        title: 'Community Amenities',
        list: [
          'Part of the prestigious Wesbrook Village community near UBC’s academic core',
          'Enjoy the convenience of shops, grocers, restaurants, cafes, and a variety of services just minutes outside your door',
          'A welcoming community with an abundance of events and activities for you and your family',
          'Nearby schools, community centres & Olympic level athletic facilities offer education and recreation for all ages',
          'Live on the edge of Pacific Spirit Park, a forested landscape with dog-friendly trails, creeks, and beaches',
          'Connect to an extensive transit network, with easy and convenient access to downtown Vancouver and the Vancouver International Airport',
        ],
      },
    ],
  },

  // NEIGHBOURHOOD
  neighbourhood: {
    title: 'Unparalleled<br /> Location',
    subtitle: 'The Neighbourhood',
    copy: `The location is perfect. Your home at Ivy on the Park is both
      scenic and convenient with access to Vancouver’s most
      sought-after places, schools and neighbourhoods. Satisfy all
      your day-to-day needs within walking distance at Wesbrook
      Village. Then venture out and enjoy the unique activities and
      character of the surrounding parks and neighbourhoods – plus the
      city-within-a-city that is yours at UBC.`,
    sections: [
      {
        title: 'Wesbrook <br /> Village',
        subtitle: 'Explore and Shop',
        copy: `Living at Ivy on the Park offers many benefits, including
          membership in the university neighbourhoods association
          (UNA). There is also the una access card, which provides
          free access to the UBC Library, Vancouver Public Library,
          UBC Botanical Garden, Nitobe Memorial Garden and Museum of
          Anthropology, plus preferred rates at UBC Athletic and
          Recreational Facilities and other venues.`,
      },
      {
        title: 'Culture<br /> Comes Home',
        subtitle: 'Living Your Best Life Is An Art',
        copy: `Like a beautiful wardrobe and the promise of an elegant
          evening, your choice of home and community defines how you
          want to live and the company you wish to keep. Cultural
          opportunities abound at UBC – from evenings at the Chan
          Centre for opera and concerts to art openings, museums and
          public lectures. Let this be your artful playground, with an
          open invitation to explore and be enchanted, steps from your
          door.`,
      },
      {
        title: 'Surrounded By The Best Educational Opportunities',
        copy: `Living at Ivy on the Park offers many benefits, including
          membership in the university neighbourhoods association (UNA).
          There is also the una access card, which provides free access
          to the UBC Library, Vancouver Public Library, UBC Botanical
          Garden, Nitobe Memorial Garden and Museum of Anthropology,
          plus preferred rates at UBC Athletic and Recreational
          Facilities and other venues.`,
      },
    ],
    map: {
      exercise: 'Exercise & Health',
      culture: 'Culture & Learning',
      eat: 'Eat & Drink',
      shops: 'Shops & Services',
      schools: 'Schools',
    },
  },

  // AMENITIES
  amenities: {
    title: 'A Distinguished<br /> Arrival',
    subtitle: 'The Amenities',
    copy: `The entrance to Ivy on the Park is distinguished by a dedicated
      driveway with beautiful landscaping that complements West Coast
      greenery. Inspired by nature, the light-filled lobby features
      contemporary wood panelling, textured stone walls, and
      sculptural black metal accents. A modern linear fireplace and
      stunning chandeliers, along with intimate seating areas, create
      focal points within the space.`,
    sections: [
      {
        title: 'Connect<br /> With Life',
        subtitle: 'Spaces to Grow',
        copy: `With an expansive selection of indoor and outdoor amenities, there is plenty to do at Ivy on the Park. Work independently in the quiet study or library, or collaborate with others in the large meeting room. Perform on the piano in the music lounge or practice your favourite instrument in the music room. Exercise your body and mind in the fitness room and yoga studio or socialize with neighbours in the Clubroom and Community patio.`,
        caption: 'Lounge',
      },
    ],
  },

  // DEVELOPER
  developer: {
    title: 'The Wall Group<br /> of Companies',
    subtitle: 'The Developer',
    copy: `<p>
        Sound investments are made with confidence. The unparalleled
        reputation of the Wall Group of Companies is built on a
        legacy of enduring success. The team’s experience includes
        developing thousands of prestigious Vancouver condominium
        residences and hotels. Today, their uncompromising standards
        are reflected in every detail of Ivy on the Park.
      </p>
      <p>
        Ivy on the Park at Wesbrook, University of British Columbia
        (UBC) is an unprecedented investment in the future – a
        lifestyle defined by education, arts, culture and
        recreation.
      </p>`,
  },

  // REGISTER
  register: {
    title: 'Register Now',
    subtitle: 'Receive Priority Information',
    form: {
      firstName: 'First Name *',
      lastName: 'Last Name *',
      email: 'Email *',
      city: 'City *',
      postal: 'Postal Code *',
      phone: 'Phone',
      realtor: 'Are you a realtor? *',
      hear: 'How did you hear about us?',
      hearOptions: [
        'Signage/Walk by/Drive by',
        'Friends and Family',
        'Newspaper Advertisement',
        'Magazine Advertisement',
        'Social Media',
        'Realtor',
        'Online Advertisement',
        'Direct Mailer',
        'Other',
      ],
      yes: 'Yes',
      no: 'No',
      consent: `Click to confirm your consent to receive e-communications from Wall
      Group of Companies and Rennie Marketing Systems including information
      about upcoming developments, VIP early access or special offers. *`,
      submit: 'Submit',
    },
  },

  // THANK YOU
  thankyou: {
    title: 'Thank you for Your Interest In IVY on the Park',
    copy: `By Registering, You Will Be The First To Receive The Latest
      Updates About This Exciting New Project.`,
    backBtn: 'Back To Home',
  },
};



// WEBPACK FOOTER //
// ./src/config/locales/en.js